import React from "react";
import { useTranslation } from "react-i18next";
import OrderForm from "./OrderForm";
import VerifyEmailForm from "./VerifyEmailForm";
import { useLocation, useNavigate } from "react-router-dom";

const InsertOtpPage = () => {
  const { t } = useTranslation();
  const { state } = useLocation()
  const login_res = state?.login_res;
  const navigate = useNavigate()

  return (
    <div className="grid grid-cols-3 h-screen w-screen bg-[#F7F7F8] p-2">
      {/* Form */}
      <div className="col-span-2 justify-left w-full h-full bg-white rounded-2xl p-[40px]">
        <p className="text-sm text-[#828282] font-normal">Step 2 {t("OF").toLowerCase()} 5</p>
        <p className="text-3xl text-black font-semibold">{t("Otp.Title")}</p>
        <p className="text-base text-[#828282] font-normal">{t("Otp.Subtitle")}</p>


        <VerifyEmailForm onNavigate={() => {
          navigate('/billing-information', { state: { login_res: login_res } })
        }} />

      </div>

      {/* Sidebar con dettagli */}
      <OrderForm showDiscount={false} login_res={login_res} />
    </div>
  );
};

export default InsertOtpPage;
